import { useState, useEffect, useRef } from "react";
import { portalClienteToken } from "../api/functions";
import DailyIframe from "@daily-co/daily-js";

export default function Sala({ chamadaId, usuario, onSair }) {
  const [status, setStatus] = useState("carregando"); // carregando | conectando | ativo | erro
  const [mensagemErro, setMensagemErro] = useState("");
  const callFrameRef = useRef(null);
  const callObjectRef = useRef(null);

  useEffect(() => {
    const iniciar = async () => {
      try {
        setStatus("carregando");

        // Busca token de convidado via backend — inclui usuario_id obrigatório
        const data = await portalClienteToken({
          chamada_id: chamadaId,
          nome: usuario.nome,
          empresa_id: usuario.empresa_id,
          usuario_id: usuario.id,
        });

        if (!data.success) throw new Error(data.error || "Chamada não disponível");

        setStatus("conectando");

        // Inicializa Daily.co
        const daily = DailyIframe.createFrame(callFrameRef.current, {
          iframeStyle: { width: "100%", height: "100%", border: "0", borderRadius: "12px" },
          showLeaveButton: false,
          showFullscreenButton: true,
          showLocalVideo: true,
          showParticipantsBar: true,
        });

        callObjectRef.current = daily;

        daily.on("joined-meeting", () => setStatus("ativo"));
        daily.on("error", (e) => { setMensagemErro(e.errorMsg || "Erro na chamada"); setStatus("erro"); });
        daily.on("left-meeting", () => onSair?.());

        await daily.join({
          url: data.room_url,
          token: data.token,
          userName: usuario.nome,
        });

      } catch (e) {
        setMensagemErro(e.message);
        setStatus("erro");
      }
    };

    iniciar();

    return () => {
      if (callObjectRef.current) {
        callObjectRef.current.leave().catch(() => {});
        callObjectRef.current.destroy().catch(() => {});
      }
    };
  }, [chamadaId]);

  const handleSair = async () => {
    try {
      if (callObjectRef.current) {
        await callObjectRef.current.leave();
        await callObjectRef.current.destroy();
        callObjectRef.current = null;
      }
    } catch {}
    onSair?.();
  };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 50, background: "#0f172a", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div style={{ padding: "12px 20px", background: "#1e293b", borderBottom: "1px solid #334155", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {status === "ativo" && <div style={{ width: "10px", height: "10px", background: "#22c55e", borderRadius: "50%" }} />}
          <span style={{ color: "#f1f5f9", fontWeight: "600", fontSize: "15px" }}>Reunião ao vivo</span>
          <span style={{ color: "#64748b", fontSize: "13px" }}>· {usuario.nome}</span>
        </div>
        <button onClick={handleSair} style={{ background: "#dc2626", color: "#fff", border: "none", padding: "8px 18px", borderRadius: "8px", fontWeight: "700", cursor: "pointer", fontSize: "13px" }}>
          📴 Sair da Reunião
        </button>
      </div>

      {/* Sala */}
      <div style={{ flex: 1, position: "relative" }}>
        <div ref={callFrameRef} style={{ width: "100%", height: "100%", position: "absolute", inset: 0 }} />

        {(status === "carregando" || status === "conectando") && (
          <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "#0f172a", zIndex: 10 }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "48px", marginBottom: "16px" }}>🎥</div>
              <p style={{ color: "#94a3b8", fontSize: "16px", marginBottom: "8px" }}>
                {status === "carregando" ? "Verificando acesso..." : "Conectando à reunião..."}
              </p>
              <p style={{ color: "#475569", fontSize: "13px" }}>Aguarde um momento</p>
            </div>
          </div>
        )}

        {status === "erro" && (
          <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "#0f172a", zIndex: 10 }}>
            <div style={{ textAlign: "center", maxWidth: "400px", padding: "20px" }}>
              <div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
              <h3 style={{ color: "#f87171", fontSize: "18px", fontWeight: "700", marginBottom: "8px" }}>Não foi possível entrar</h3>
              <p style={{ color: "#94a3b8", fontSize: "14px", marginBottom: "24px" }}>{mensagemErro}</p>
              <button onClick={onSair} style={{ background: "#334155", color: "#f1f5f9", border: "none", padding: "10px 24px", borderRadius: "10px", cursor: "pointer", fontWeight: "600" }}>Voltar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
